import utdRest from '_acaSrc/utility/http/UtdRestHooks';

export const EMAIL_CHECK_RESULT = {
    ELIGIBLE: 'eligible',
    FREE_TRIAL_UNAVAILABLE: 'free_trial_unavailable',
    NOT_ELIGIBLE: 'not_eligible',
    EXISTING_ACCOUNT_SSO: 'existing_account_sso'
};

export const checkEmailEligibility = async(email) => {
    const result = await utdRest('register/checkEmailFreeTrial', { email: email.trim() });

    if (!result.hasUser) {
        return { result: EMAIL_CHECK_RESULT.ELIGIBLE };
    }
    if (result.previousFreeTrial) {
        return { result: EMAIL_CHECK_RESULT.FREE_TRIAL_UNAVAILABLE };
    }
    if (result.isSsoDomain && result.wayfInfo?.url) {
        return { result: EMAIL_CHECK_RESULT.EXISTING_ACCOUNT_SSO, wayfInfo: result.wayfInfo };
    }
    return { result: EMAIL_CHECK_RESULT.NOT_ELIGIBLE };
};

export const checkNpiValidity = async(npi) => {
    const result = await utdRest('register/checkNpiFreeTrial', { npi: npi.trim() });
    return { isValid: !result.previousFreeTrial };
};



